<ngx-spinner type="ball-scale-multiple">
  <!-- <p-progressSpinner></p-progressSpinner> -->
</ngx-spinner>

<!-- <ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#ffffff"
  type="ball-scale-multiple"
  [fullScreen]="true">
</ngx-spinner> -->

<router-outlet></router-outlet>